import * as React from 'react'
import SearchComponent from './Seach.component';
import Wrapper from 'src/components/Wrapper';
import { RouteComponentProps, withRouter } from 'react-router';
import { parseQuery } from './Search.utils';
import { searchCourses } from 'src/helpers/api';
import { ICourseSearchResultItem, INewsSearchResultItem } from 'src/types/SearchResult';
import { ISearchBarState } from 'src/components/SearchBar';
import { CourseSearchResult } from './SearchResult.component';
import Title from 'src/components/Title';
import Breadcrumb from 'src/components/Breadcrumb';
import BreadcrumbItem from 'src/components/Breadcrumb/BreadcrumbItem';
import { Link } from 'react-router-dom';
import { usePageModals } from 'src/shared/Modal';
import { DotLoader } from 'src/components/Loaders';

interface ISearchPageState {
  loading: boolean;
  courses: ICourseSearchResultItem[];
  news: INewsSearchResultItem[];
}

const useRouteSearchQuery = (props: RouteComponentProps): ISearchBarState => React.useMemo(
  () => parseQuery(props.location.search),
  [props.location.search]
);

const SearchPage = (props: RouteComponentProps) => {
  const modals = usePageModals();
  const abortControllerRef = React.useRef<AbortController | null>(null);
  const [state, setState] = React.useState<ISearchPageState>({
    loading: false,
    courses: [],
    news: []
  });

  const query = useRouteSearchQuery(props);

  const searchCoursesAndNews = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
    }

    let nextState = { ...state, loading: true };
    const abortController = new AbortController();
    abortControllerRef.current = abortController;

    setState(nextState);

    const promises: Array<Promise<any>> = [
      searchCourses(query, { signal: abortController.signal })
        .then((result) => {
          nextState = { ...nextState, courses: result.results }
          setState(nextState);
        })
    ];

    Promise.all(promises)
      .finally(() => {
        nextState = { ...nextState, loading: false };
        setState(nextState);
      });
  };

  React.useEffect(() => {
    searchCoursesAndNews();
  }, [query]);

  React.useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  return (
    <div>
      <Wrapper className="pt3">
        <Breadcrumb>
          <BreadcrumbItem>
            <Link to="/Home">FORSIDE</Link>{' '}
          </BreadcrumbItem>
          <BreadcrumbItem active={true}>
            <Link to="/kurser/">KURSER</Link>{' '}
          </BreadcrumbItem>
        </Breadcrumb>
      </Wrapper>

      <div className="has-background-gray-body mt-3 pt-10 pb-16 min-h-screen">
        <Wrapper>
          <div className="has-background-white pr-14 mt-12">
            <SearchComponent
              className="-mt-6"
              initialState={query}
              style={{ transform: 'translateY(-1.5rem)' }}
            />
            <div className="pt-10 pb-5 pl-5 -mt-6 has-text-black">
              <h3 className="text-lg font-extrabold m-0 uppercase ml-5">Søgeresultat</h3>
              {state.courses.length > 0 && (
                <CourseSearchResult
                  results={state.courses}
                />
              )}
            </div>
          </div>
        </Wrapper>
      </div>
    </div>
  );
};

export default withRouter(SearchPage);



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/SeachPage/index.tsx